import React from "react";
import MessageState from "./message-state";

function NoAssessments() {
  return <MessageState title="No work yet" message="There is no work assigned to you right now. Check back later." />;
}

export default NoAssessments;
